import { render } from "./LikertCompositeQuestion.vue?vue&type=template&id=0d9c4c5c&scoped=true"
import script from "./LikertCompositeQuestion.vue?vue&type=script&lang=js"
export * from "./LikertCompositeQuestion.vue?vue&type=script&lang=js"

import "./LikertCompositeQuestion.vue?vue&type=style&index=0&id=0d9c4c5c&lang=less&scoped=true"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9c4c5c"]])

export default __exports__